import { EmailTemplate } from "./baseTemplate";
import { TemplateName, TemplateVariable, } from "./types";
export class TierIIEmailTemplate extends EmailTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.TierIIEmail;
    }
    subject({ communication }) {
        const report = communication.tierIIReports[0];
        const facilityNames = this.getFacilityNames(communication.facilities);
        const prefix = this.getPrefix(report?.reportKind);
        const shortReportingYear = this.getShortReportingYear(report?.reportingYear);
        // Include tracking ID in subject line for easy reference by regulators
        const trackingSuffix = communication.trackingId
            ? ` [${communication.trackingId}]`
            : "";
        return `${prefix} - ${facilityNames} - RY${shortReportingYear}${trackingSuffix}`;
    }
    extractVariables({ communication }) {
        return {
            [TemplateVariable.FacilityNames]: communication.facilities
                .map((f) => this.identifierSection(f))
                .join("<br /><br />"),
            [TemplateVariable.CompanyName]: communication.tenant.name,
        };
    }
    rawTemplate() {
        return this.baseText({
            identifierSection: `{{${TemplateVariable.FacilityNames}}}`,
            companyName: `{{${TemplateVariable.CompanyName}}}`,
            isRevision: false,
        });
    }
    text({ communication }) {
        const report = communication.tierIIReports[0];
        const variables = this.extractVariables({ communication });
        return this.baseText({
            identifierSection: variables[TemplateVariable.FacilityNames],
            companyName: variables[TemplateVariable.CompanyName],
            isRevision: report?.reportKind === "REVISION",
        });
    }
    getShortReportingYear(year) {
        // If the year is less than 100, it's a 2-digit year
        if (year < 100) {
            return year.toString();
        }
        // If the year is greater than 100, it's a 4-digit year
        return year.toString().slice(-2);
    }
    getPrefix(reportKind) {
        const isRevision = reportKind === "REVISION";
        const prefix = isRevision ? "Tier II Revision" : "Tier II Submission";
        return prefix;
    }
    getFacilityNames(facilities) {
        if (facilities.length === 1) {
            return facilities[0].name;
        }
        return `(${facilities.map((f) => f.name).join(", ")})`;
    }
}
//# sourceMappingURL=tierIIEmailTemplate.js.map